module.exports = __webpack_public_path__ + "static/img/swiper-6.7855a5fd.png";